import { useCallback, useEffect, useRef, useState } from "react"

interface TypewriterResult {
    displayed: string
    isDone: boolean
    skip: () => void
}

export function useTypewriter(text: string, speed = 30): TypewriterResult {
    const [displayed, setDisplayed] = useState("")
    const [isDone, setIsDone] = useState(false)
    const indexRef = useRef(0)
    const timerRef = useRef<ReturnType<typeof setInterval>>()

    useEffect(() => {
        setDisplayed("")
        setIsDone(false)
        indexRef.current = 0

        if (!text) {
            setIsDone(true)
            return
        }

        timerRef.current = setInterval(() => {
            indexRef.current += 1
            if (indexRef.current >= text.length) {
                setDisplayed(text)
                setIsDone(true)
                clearInterval(timerRef.current)
            } else {
                setDisplayed(text.slice(0, indexRef.current))
            }
        }, speed)

        return () => {
            clearInterval(timerRef.current)
        }
    }, [text, speed])

    const skip = useCallback(() => {
        clearInterval(timerRef.current)
        setDisplayed(text)
        setIsDone(true)
    }, [text])

    return { displayed, isDone, skip }
}
